const getNextActiveScreen = ({ extra_config }, currentPage, url) => {
  const nextActionPageIndex = extra_config
    .filter(({ is_active }) => is_active === 'true')
    .findIndex(({ page }) => page === currentPage);

  const checkNextItem = (nextItem) => {
    if (nextItem?.is_active === 'true') {
      return nextItem;
    }
    return null;
  };

  const nextPage = nextActionPageIndex !== -1
    ? checkNextItem(extra_config.filter(({ is_active }) => is_active === 'true')[nextActionPageIndex + 1])
    : null;

  if (nextPage && 'page' in nextPage) {
    return `${url}/${nextPage.page.replace(/_/g, '-')}`;
  }
  return '/help/form-page';
};

export default getNextActiveScreen;
